module.exports = __webpack_public_path__ + "img/wrongspelling.0a9bf773.jpg";